module.exports = __webpack_public_path__ + "img/icon_card12.17a026c6.png";